<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        My Request
      </h2>
    </div>

    <div class="flex w-full menucontrol-scroll fixed-top bg-white">
      <div class="w-full">
        <div class="grid p-8 grid-cols-2 gap-8 w-full pb-8">
          <div
            class="flex items-start border rounded-10px cursor-pointer p-4"
            v-for="(item, index) in this.getextensionsrequests"
            :key="index"
          >
            <div class="w-9/12 flex items-center gap-6">
              <img
                :src="showImage(item.extensionId.image)"
                class="object-contain wh-75px rounded-10px p-3 bg-cas"
                alt="banh"
              />

              <div>
                <h2 class="col-4f text-xl mb-0 font-semibold">
                  {{ item.extensionId.name }}
                </h2>
                <p
                  class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                >
                  {{ getDate(item.createdAt) }}
                </p>
              </div>
            </div>
            <div class="w-3/12">
              <div class="flex justify-end">
                <p
                  class="bg-light-orange fsize10 flex justify-center border-round py-1 px-4"
                >
                  {{ item.status }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mt-32 flex text-center justify-center"
          v-if="!getextensionsrequests.length"
        >
          <div>
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/file.svg"
              alt="image"
              class="w-4/5"
            />
            <h6 class="text-black foont-semibold mt-1 text-xl text-center">
              No Data Found
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Plans2 from "@/views/adminPanel/pages/ecommerce/components/Plans2";

export default {
  data() {
    return {};
  },
  components: {
    Plans2,
  },
  mounted() {
    let getReq = this.$store.dispatch("Extensions/getExtensionRequest", {
      status: "Pending",
      projectName: this.selectedProject.projectName,
    });
  },
  computed: {
    ...mapState("Extensions", ["getextensionsrequests", "extensionsorders"]),
    ...mapState("user", ["selectedProject"]),
  },
  methods: {
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
  },
};
</script>
